import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "coverage-details mb-4" }
const _hoisted_6 = { class: "d-flex flex-wrap coverage-details__row" }
const _hoisted_7 = { class: "coverage-details__item flex-grow-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Participant ID", -1)
const _hoisted_9 = { class: "coverage-details__item flex-grow-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "SSN", -1)
const _hoisted_11 = { class: "coverage-details__item flex-grow-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Name", -1)
const _hoisted_13 = { class: "coverage-details__item flex-grow-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Date of Birth", -1)
const _hoisted_15 = { class: "coverage-details__item flex-grow-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Gender", -1)
const _hoisted_17 = { class: "coverage-details__item w-100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Marital Status", -1)
const _hoisted_19 = { class: "coverage-details__item w-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "Address", -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "coverage-details" }
const _hoisted_23 = {
  key: 0,
  class: "d-flex flex-wrap coverage-details__row"
}
const _hoisted_24 = { class: "coverage-details__item flex-basis-half" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Current Coverage Status", -1)
const _hoisted_26 = { class: "coverage-details__item flex-basis-half" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Start of Current Coverage", -1)
const _hoisted_28 = { class: "coverage-details__item flex-basis-half" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "Available RMRP Balance", -1)
const _hoisted_30 = { class: "coverage-details__item flex-basis-half" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "End of Current Coverage", -1)
const _hoisted_32 = { class: "plan-upcoming" }
const _hoisted_33 = { class: "container-fluid" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-10" }
const _hoisted_36 = { class: "plan-general-details plan-navigation" }
const _hoisted_37 = { class: "plan-upcoming-navigation" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 2,
  class: "pending-period"
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "col-md-2" }
const _hoisted_48 = { class: "contribution-table" }
const _hoisted_49 = { class: "capp-account bordered-card width-30" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h4", null, " R-MRP Account ", -1)
const _hoisted_51 = {
  key: 0,
  class: "contribution-left-table"
}
const _hoisted_52 = { class: "contribution-left-line" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h5", null, " Previous Balance: ", -1)
const _hoisted_54 = { class: "contribution-left-lines" }
const _hoisted_55 = { class: "contribution-left-line" }
const _hoisted_56 = { class: "flex" }
const _hoisted_57 = { class: "contribution-left-line" }
const _hoisted_58 = { class: "flex" }
const _hoisted_59 = { class: "contribution-left-line" }
const _hoisted_60 = { class: "flex" }
const _hoisted_61 = { class: "contribution-left-line" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h5", null, " Total Contributions ", -1)
const _hoisted_63 = { class: "contribution-left-lines" }
const _hoisted_64 = { class: "contribution-left-line" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h5", null, " Admin Fees: ", -1)
const _hoisted_66 = { class: "contribution-left-line" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "contribution-left-line" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h5", null, " Amount Available: ", -1)
const _hoisted_70 = { class: "contribution-left-line" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h5", null, " Co-Payment: ", -1)
const _hoisted_72 = { class: "contribution-left-line" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h5", null, " Premium Payment: ", -1)
const _hoisted_74 = { class: "contribution-left-line" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h5", null, " Transfers/Waivers: ", -1)
const _hoisted_76 = { class: "contribution-left-line" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h5", null, " Ending Balance ", -1)
const _hoisted_78 = { class: "contributions-tables" }
const _hoisted_79 = { class: "contributions-table-wrapper" }
const _hoisted_80 = { class: "contributions-table-item" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("h4", null, " Contribution Detail ", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Receipt Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Wk End"),
    /*#__PURE__*/_createElementVNode("th", null, "Employer/Production"),
    /*#__PURE__*/_createElementVNode("th", null, "Report"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount")
  ])
], -1)
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, "No contributions found.")
], -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "contributions-table-wrapper" }
const _hoisted_88 = { class: "contributions-table-item" }
const _hoisted_89 = { class: "d-flex w-100 align-items-center justify-content-between" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Begins"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Sent"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Due Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1)
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, "No statements found.")
], -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "plan-summary__footer row w-100 w-sm-100" }
const _hoisted_96 = { class: "col-12 col-md-4" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("h4", { class: "sm-fs-base" }, "Other Coverages", -1)
const _hoisted_98 = { class: "account-actions" }
const _hoisted_99 = { class: "col-12 col-md-8" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("h4", { class: "sm-fs-base" }, "Account Actions", -1)
const _hoisted_101 = { class: "action-buttons flex-md-row flex-column mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OtherCoverages = _resolveComponent("OtherCoverages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", null, _toDisplayString($setup.participantDetails.ParticipantID ?? 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", null, _toDisplayString($setup.participantDetails.SSN ?? 'N/A'), 1),
                _createElementVNode("p", {
                  class: "plan-modal text-underline text-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openModal('recaptcha', 'Show SSN', 'modal-success')), ["prevent"]))
                }, "Show SSN")
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString($setup.participantDetails.Name ?? 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("p", null, _toDisplayString($setup.participantDetails.DateofBirth ?? 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", null, _toDisplayString($setup.participantDetails.Gender ?? 'N/A'), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("p", null, _toDisplayString($setup.planSummary.MaritalStatus), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString($setup.participantDetails.AddressFormatted ?? 'N/A'), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            ($setup.dataLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", null, "Plan " + _toDisplayString($setup.planSummary.Coverage?.Plan ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("p", null, _toDisplayString($setup.planSummary.Coverage ? $setup.planSummary.Coverage.From : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("p", null, _toDisplayString($setup.planSummary.Coverage ? $setup.formatCurrency($setup.planSummary.Coverage.RmrpBalance) : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("p", null, _toDisplayString($setup.planSummary.Coverage ? $setup.planSummary.Coverage.To : '-'), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.navigateToPrevious && $setup.navigateToPrevious(...args)), ["prevent"])),
                  disabled: !$setup.canMovePrev,
                  class: "btn btn-primary btn-navigation btn-prev"
                }, _hoisted_40, 8, _hoisted_38),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formattedPeriods, (period, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(['period', { 'current-period': period.IsCurrent, 'active-period': period.IsActive }])
                  }, [
                    _createTextVNode(_toDisplayString(period.FromFormatted) + " - " + _toDisplayString(period.ToFormatted) + " ", 1),
                    (period.IsCurrent)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_41, "Current"))
                      : (period.IsUpcoming)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_42, _toDisplayString(period.IsUpcoming), 1))
                        : (period.IsPending !== false)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_43, _toDisplayString(period.IsPending), 1))
                          : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.navigateToNext && $setup.navigateToNext(...args)), ["prevent"])),
                  disabled: !$setup.canMoveNext,
                  class: "btn btn-primary btn-navigation btn-next"
                }, _hoisted_46, 8, _hoisted_44)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-tertiary",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.openModal('coverage-history', 'Coverage History', '', null, null, null)), ["prevent"]))
            }, "Coverage History")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _hoisted_50,
        ($setup.dataLoaded && $setup.planSummary.CappAccount && Object.keys($setup.planSummary.CappAccount).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.PREVBAL)), 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["month", { 'current': $setup.selectedMonth === $setup.planSummary.CappAccount.CONTRIB1?.MonthName }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectMonth($setup.planSummary.CappAccount.CONTRIB1?.MonthName)))
                  }, _toDisplayString($setup.formatDateToMonth($setup.planSummary.CappAccount.CONTRIB1?.MonthName)), 3),
                  _createElementVNode("h5", _hoisted_56, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.CONTRIB1.Value)), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["month", { 'current': $setup.selectedMonth === $setup.planSummary.CappAccount.CONTRIB2?.MonthName }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.selectMonth($setup.planSummary.CappAccount.CONTRIB2?.MonthName)))
                  }, _toDisplayString($setup.formatDateToMonth($setup.planSummary.CappAccount.CONTRIB2?.MonthName)), 3),
                  _createElementVNode("h5", _hoisted_58, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.CONTRIB2.Value)), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["month", { 'current': $setup.selectedMonth === $setup.planSummary.CappAccount.CONTRIB3?.MonthName }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectMonth($setup.planSummary.CappAccount.CONTRIB3?.MonthName)))
                  }, _toDisplayString($setup.formatDateToMonth($setup.planSummary.CappAccount.CONTRIB3?.MonthName)), 3),
                  _createElementVNode("h5", _hoisted_60, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.CONTRIB3.Value)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.TOTCONT)), 1)
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.ADMINFEE * -1)), 1)
                ]),
                _createElementVNode("div", _hoisted_66, [
                  ($setup.planSummary.CappAccount.REIMB !== 0)
                    ? (_openBlock(), _createElementBlock("h5", {
                        key: 0,
                        class: "link-text",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.openModal('hw-mrp-history', 'Medical Reimbursements History', 'plan-mrp', null, null, null, null, { From: $setup.planSummary.MrpFrom , To: $setup.planSummary.MrpTo })), ["prevent"]))
                      }, " Medical Reimbursements: "))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_67, " Medical Reimbursements: ")),
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.REIMB)), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.AMTAVAIL)), 1)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.COPAY)), 1)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.PREMPAY)), 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createElementVNode("h5", null, _toDisplayString($setup.planSummary.CappAccount.XFERWAIV != 0 ? $setup.formatCurrency($setup.planSummary.CappAccount.XFERWAIV * -1) : $setup.formatCurrency($setup.planSummary.CappAccount.XFERWAIV)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency($setup.planSummary.CappAccount.BALANCE)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _hoisted_81,
            _createElementVNode("table", null, [
              _hoisted_82,
              ($setup.filteredContributionDetails && $setup.filteredContributionDetails.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_83, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredContributionDetails, (contribution) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: contribution.ReportID
                      }, [
                        _createElementVNode("td", null, _toDisplayString(contribution.ReceiptDate), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.PeriodEnd), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.Employer) + " / " + _toDisplayString(contribution.Production), 1),
                        _createElementVNode("td", null, _toDisplayString(contribution.ReportID), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(contribution.Amount)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_84, _hoisted_86))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("h4", _hoisted_89, [
              _createTextVNode(" Statement Activity "),
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-tertiary",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.openModal('hw-capp-payments-history', 'CAPP Statements History', '', null, null, null)), ["prevent"]))
              }, "CAPP Statement/Co-Pay History")
            ]),
            _createElementVNode("table", null, [
              _hoisted_90,
              ($setup.planSummary.CappStatements && $setup.planSummary.CappStatements.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_91, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.planSummary.CappStatements, (statement) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: statement.ID
                      }, [
                        _createElementVNode("td", null, _toDisplayString(statement.CoverageBegins), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.Type), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.DateSent), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.Status), 1),
                        _createElementVNode("td", null, _toDisplayString(statement.DueDate), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(statement.Balance)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_92, _hoisted_94))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_95, [
      _createElementVNode("div", _hoisted_96, [
        _hoisted_97,
        _createElementVNode("div", _hoisted_98, [
          _createVNode(_component_OtherCoverages, {
            otherCoverages: $setup.planSummary.OtherCoverages
          }, null, 8, ["otherCoverages"])
        ])
      ]),
      _createElementVNode("div", _hoisted_99, [
        _hoisted_100,
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary plan-modal",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => ($setup.openModal('add-beneficiary', 'My Beneficiary(ies)', 'plan-tables-striped beneficiary', null, null, null
                        )), ["prevent"]))
          }, " Beneficiary(ies) "),
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => ($setup.openModal('claims', 'Claims', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
          }, " Claims "),
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => ($setup.openModal('dependents', 'My Dependents', null)), ["prevent"]))
          }, "My Dependents ")
        ])
      ])
    ])
  ]))
}